import Loader from '~/components/Loading/List'
import Loadable from '~/utils/loadable'

export default Loadable({
  loader: () => import('./Reports'),
  loading: Loader,
})
